import React, { useContext } from 'react';
import { GlobalContext } from '../../utilities/GlobalContext';
import styleFunctions from '../../utilities/styles/functions';

function NavStyles () {
    //#region Params
    
    //#endregion

    //#region Style vars
    
    //#endregion

    //#region seting vars based off params
    
    //#endregion

    let styles = {
        outerStyle: () => {
            return({
                width: '100vw',
                height: '100vh',
                backgroundSize: 'fill',
                backgroundColor: 'black',
                position: 'fixed',
                zIndex: '-3',
                display: 'flex',
                margin: 0,
                padding: 0,
            });
        },
        backgroundImage: () => {
            return({
                width: '100%',
                height: '100%',
                position: 'fixed',
                objectFit: 'cover',
                backgroundColor: 'black',
                backgroundSize: 'cover',
                display: 'flex',
                zIndex: -1,
                margin: '-1px'
            });
        },
        contentContainer: () => {
            return({
                margin: 'auto',
                color: 'white',
                fontSize: '4rem'
             });
        },
        title: () => {
            return({
                margin: 0,
                color: 'white',
                fontSize: '4rem'
            });
        }
    }

    styleFunctions.call(styles);

    return(styles);
}

export default NavStyles;